// Used for routes
export const ALL_ASSETS = 'all'

export const EBISU_MAIN_ADDRESS = 'EFVHUEC4L5PMBNZ6G2QGQSKQSPQ6TQD3NMJISVWZVYVFW3I7CRG65NNO5M'
export const EBISU_DONATION_ADDRESS = 'CN5H5XSQPAVSRX7EVUQB3LJGVD5J537IBPPJ6YUSBLZPYP5EVB6EEO6O7U'
export const ALGO_BURN_ADDRESS = 'FRWQZO4A6NZKANEYYWAHZIBHJ46T2LVRFACCLHUY3JQAJLUIWNQQLOQ26A'
